import React, { useState, useEffect } from 'react'
import { useParams,useNavigate, NavLink } from 'react-router-dom';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';
import  { GetCourseInfo }  from '../../controllers/GetCourseInfo';
import  { GetContentInfo }  from '../../controllers/GetContentInfo';
import {encode as base64_encode} from 'base-64';
import { Navbar } from '../ui/NavBar';
import { Button } from "@wfp/ui";
import  { GetCourseChild }  from '../../controllers/GetCourseChild';
import  { ProgressInsert }  from '../../controllers/ProgressInsert';
import  { GetContentCourseLevel }  from '../../controllers/GetContentCourseLevel';
import  { GetQuestionCourseLevel }  from '../../controllers/GetQuestionCourseLevel';
import  { CourseEnding }  from '../../controllers/CourseEnding';
import  { GetCourseFather }  from '../../controllers/GetCourseFather';
import  { PositionUpdate }  from '../../controllers/PositionUpdate';
import  { positionByCourse }  from '../../controllers/positionByCourse';
import ReactPlayer from "react-player";
// Home to display "Pregunta"
export const InformationScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();

    const [info, setInfo] = useState("");
    const [nameUnit, setNameUnit] = useState("");
    const cursoId = localStorage.getItem('courseId');
    const cursoColor = localStorage.getItem('courseColor');
    const [course, setCourse] = useState([]);
    const [cursoNombre, setCursoNombre] = useState('');
    const { fatherId } = useParams();
    const { unitId } = useParams();
    const { questionId } = useParams();
    localStorage.setItem('child',unitId);
    const [url, setUrl] = useState('');
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const [routerInfo, setRouterInfo] = useState("");
    const [video, setVideo] = useState("");

    let ranonce = false;
    useEffect(() => {
        if (ranonce) return;
            positionByCourse( token, user.id, cursoId)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                // console.log({e})
                PositionUpdate( token, user.id, cursoId, `/information/${ fatherId }/${ unitId }/${ questionId }`, e[0].id)
                .catch((e)=>{
                    console.error(e);
                    // dispatch(logout(token));
                });
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
            GetCourseChild(cursoId, user.languaje, token, user.id, fatherId)
            .then((res)=>{

                let found = res.find(element => element.id === parseInt(unitId));
                
                if(found?.progress_id === null ){
                    ProgressInsert(token, user.id, found.id )
                    .catch((e)=>{
                        console.error(e);
                        //dispatch(logout(token));
                    });
                }
                if(found?.text_value !== null  && found?.text_value !== undefined){
                    setNameUnit(found.text_value)
                }
                setRouterInfo(res)
            })
            .catch((e)=>{
                console.error(e);
                //dispatch(logout(token));
            });

            GetCourseInfo(cursoId, user.languaje, token, user.id)
            .then((e)=>{
                setCourse(e[0]);
                setCursoNombre(e[0].name)
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
        return () => (ranonce = true);
    }, [])

    let ran = false;
    useEffect(() => {
        if (ran) return;
        GetContentInfo(unitId, user.languaje, token, user.id)
        .then((e)=>{
            e.sort((a, b) => a.id - b.id);
            let found = e.find(element => element?.id === parseInt(questionId));
            setInfo(found)
            if(found?.video_url !==null ){
                setVideo(found.video_url)
            }
            // console.log(found)
            if(found?.progress_id === null ){
                ProgressInsert(token, user.id, found.id, "content")
                .catch((e)=>{
                    console.error(e);
                    //dispatch(logout(token));
                });
            }
        })
        .catch((e)=>{
            console.error(e);
            //dispatch(logout(token));
        });
        return () => (ran = true);
    }, [questionId])

    useEffect(() => {
        const getData = async (info, routerInfo) => {
        if(info && routerInfo){
            let found = routerInfo.find(element => element.id === parseInt(unitId));
            if(found.content_numbers > 1){
                await GetContentCourseLevel(unitId, user.languaje, token, user.id)
                .then((e)=>{
                    e.sort((a, b) => a.id - b.id);
                    let enterQ = 0;
                    e.forEach(element => {
                        
                        if(element.id > info.id && enterQ === 0){
                            enterQ++;
                            setUrl(`/information/${fatherId}/${unitId}/${element.id}`)
                        }
                    });
                    if(enterQ === 0 && found.question_numbers === null){
                        if(localStorage.getItem('gChildFather')){
                            setUrl(`/gchild/${localStorage.getItem('gChildFather')}/${fatherId}`)
                            if( found && found.ending_id === null ){
                                CourseEnding(token, user.id, unitId)
                                .catch((e)=>{
                                    console.error(e);
                                    dispatch(logout(token));
                                });
                            }
                            let enterGCUQ = 0;
                            routerInfo.forEach(element => {
                                if(element.id > parseInt(unitId) && enterGCUQ === 0){
                                    enterGCUQ++;
                                }
                            });
                            if(enterGCUQ === 0){
                                setUrl(`/child/${localStorage.getItem('childFather')}/${localStorage.getItem('gChildFather')}`)
                                GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('gChildFather'))
                                .then((e)=>{
                                    let found = e.find(element => element?.id === parseInt(fatherId));
                                    if( found && found.ending_id === null ){
                                        CourseEnding(token, user.id, fatherId)
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                    }
                                    let enterUQ = 0;
                                    routerInfo.forEach(element => {
                                        if(element.id > parseInt(fatherId) && enterUQ === 0){
                                            enterUQ++;
                                        }
                                    });
                                    if(enterUQ === 0){
                                        setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${localStorage.getItem('childFather')}`)
                                        GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('childFather'))
                                        .then((e)=>{
                                            let found = e.find(element => element?.id === parseInt(localStorage.getItem('gChildFather')));
                                            if( found && found.ending_id === null ){
                                                CourseEnding(token, user.id, localStorage.getItem('gChildFather'))
                                                .catch((e)=>{
                                                    console.error(e);
                                                    dispatch(logout(token));
                                                });
                                            }
                                            let enterQF = 0;
                                            e.forEach(element => {
                                                if(element.id > parseInt(localStorage.getItem('gChildFather')) && enterQF === 0){
                                                    enterQF++;
                                                }
                                            });
                                            if(enterQF === 0){
                                                
                                                setUrl(`/units/${cursoId}`)
                                                GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('lessonFather'))
                                                .then((e)=>{
                                                    let found = e.find(element => element?.id === parseInt(localStorage.getItem('childFather')));
                                                    
                                                    if( found && found.ending_id === null ){
                                                        CourseEnding(token, user.id, localStorage.getItem('childFather'))
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            dispatch(logout(token));
                                                        });
                                                        const lastElement = e.pop();
                                                        if(lastElement.id === parseInt(localStorage.getItem('childFather'))){
                                                            setUrl(`/finish/${cursoId}`);
                                                        }
                                                    }
                                                    let found1 = e.find(element => element && element?.ending_id === null);
                                                    if(typeof found1 === 'undefined' ){
                                                        setUrl(`/finish/${cursoId}`);
                                                    }
                                                    
                                                    let enterQFL = 0;
                                                    e.forEach(element => {
                                                        if(element.id > parseInt(localStorage.getItem('childFather')) && enterQFL === 0){
                                                            enterQFL++;
                                                        }
                                                    });
                                                    if(enterQFL === 0){
                                                        GetCourseFather(cursoId, user.languaje, token, user.id)
                                                        .then((e)=>{
                                                            let found = e.find(element => element?.id === parseInt(localStorage.getItem('lessonFather')));
                                                            if( found && found.ending_id === null ){
                                                                CourseEnding(token, user.id, localStorage.getItem('lessonFather'))
                                                                .catch((e)=>{
                                                                    console.error(e);
                                                                    dispatch(logout(token));
                                                                });
                                                            }
                                                        })
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            //dispatch(logout(token));
                                                        });
                                                    }
                                                })
                                                .catch((e)=>{
                                                    console.error(e);
                                                    //dispatch(logout(token));
                                                });
                                                
                                            }
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            //dispatch(logout(token));
                                        });
                                        
                                    }
                                })
                                .catch((e)=>{
                                    console.error(e);
                                    dispatch(logout(token));
                                });
                            }        
                        }
                        else if(localStorage.getItem('childFather')){
                            setUrl(`/child/${localStorage.getItem('childFather')}/${fatherId}`)
                            if( found && found.ending_id === null ){
                                CourseEnding(token, user.id, unitId)
                                .catch((e)=>{
                                    console.error(e);
                                    dispatch(logout(token));
                                });
                            }
                            let enterUQ = 0;
                            routerInfo.forEach(element => {
                                if(element.id > parseInt(unitId) && enterUQ === 0){
                                    enterUQ++;
                                }
                            });
                            if(enterUQ === 0){
                                setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${localStorage.getItem('childFather')}`)
                                GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('childFather'))
                                .then((e)=>{
                                    let found = e.find(element => element?.id === parseInt(fatherId));
                                    if( found && found.ending_id === null ){
                                        CourseEnding(token, user.id, fatherId)
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                    }
                                    let enterQF = 0;
                                    e.forEach(element => {
                                        if(element.id > parseInt(fatherId) && enterQF === 0){
                                            enterQF++;
                                        }
                                    });
                                    if(enterQF === 0){
                                        
                                        setUrl(`/units/${cursoId}`)
                                        GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('lessonFather'))
                                        .then((e)=>{
                                            let found = e.find(element => element?.id === parseInt(localStorage.getItem('childFather')));
                                            
                                            if( found && found.ending_id === null ){
                                                CourseEnding(token, user.id, localStorage.getItem('childFather'))
                                                .catch((e)=>{
                                                    console.error(e);
                                                    dispatch(logout(token));
                                                });
                                                const lastElement = e.pop();
                                                if(lastElement.id === parseInt(localStorage.getItem('childFather'))){
                                                    setUrl(`/finish/${cursoId}`);
                                                }
                                            }
                                            let found1 = e.find(element => element && element?.ending_id === null);
                                            if(typeof found1 === 'undefined' ){
                                                setUrl(`/finish/${cursoId}`);
                                            }
                                            
                                            let enterQFL = 0;
                                            e.forEach(element => {
                                                if(element.id > parseInt(localStorage.getItem('childFather')) && enterQFL === 0){
                                                    enterQFL++;
                                                }
                                            });
                                            if(enterQFL === 0){
                                                GetCourseFather(cursoId, user.languaje, token, user.id)
                                                .then((e)=>{
                                                    let found = e.find(element => element?.id === parseInt(localStorage.getItem('lessonFather')));
                                                    if( found && found.ending_id === null ){
                                                        CourseEnding(token, user.id, localStorage.getItem('lessonFather'))
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            dispatch(logout(token));
                                                        });
                                                    }
                                                })
                                                .catch((e)=>{
                                                    console.error(e);
                                                    //dispatch(logout(token));
                                                });
                                            }
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            //dispatch(logout(token));
                                        });
                                        
                                    }
                                })
                                .catch((e)=>{
                                    console.error(e);
                                    //dispatch(logout(token));
                                });
                                
                            }
                        }
                        else if(localStorage.getItem('lessonFather')){
                            setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${fatherId}`)
                            if( found && found.ending_id === null ){
                                CourseEnding(token, user.id, unitId)
                                .catch((e)=>{
                                    console.error(e);
                                    dispatch(logout(token));
                                });
                            }
                            let enterUQ = 0;
                            routerInfo.forEach(element => {
                                if(element.id > parseInt(unitId) && enterUQ === 0){
                                    enterUQ++;
                                }
                            });
                            if(enterUQ === 0){
                                setUrl(`/units/${cursoId}`)
                                GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('lessonFather'))
                                .then((e)=>{
                                    let found = e.find(element => element?.id === parseInt(fatherId));
                                    if(found && found.ending_id === null ){
                                        CourseEnding(token, user.id, fatherId)
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                    }
                                    
                                    let enterQFL = 0;
                                    e.forEach(element => {
                                        if(element.id > parseInt(fatherId) && enterQFL === 0){
                                            enterQFL++;
                                        }
                                    });
                                    if(enterQFL === 0){
                                        GetCourseFather(cursoId, user.languaje, token, user.id)
                                        .then((e)=>{
                                            let found = e.find(element => element?.id === parseInt(fatherId));
                                            
                                            
                                            if(found && found.ending_id === null ){
                                                CourseEnding(token, user.id, fatherId)
                                                .catch((e)=>{
                                                    console.error(e);
                                                    dispatch(logout(token));
                                                });
                                                const lastElement = e.pop();
                                                if(lastElement.id === parseInt(fatherId)){
                                                    setUrl(`/finish/${cursoId}`);
                                                }
                                            }
                                            let found1 = e.find(element => element && element?.ending_id === null);
                                            if(typeof found1 === 'undefined' ){
                                                setUrl(`/finish/${cursoId}`);
                                            }
                                          
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            //dispatch(logout(token));
                                        });
                                    }
                                })
                                .catch((e)=>{
                                    console.error(e);
                                    //dispatch(logout(token));
                                });
                                        
                            }
                        }
                    }
                    else if(enterQ === 0 && found.question_numbers > 0){
                        GetQuestionCourseLevel(unitId, user.languaje, token, user.id)
                        .then((e)=>{
                            let enterQ = 0;
                            e.forEach(element => {
                                if(element.id > 0 && enterQ === 0){
                                    enterQ++;
                                    setUrl(`/question/${fatherId}/${unitId}/${element.id}`)
                                }
                            });
                        })
                        .catch((e)=>{
                            console.error(e);
                            // dispatch(logout(token));
                        });
                    }

                })
                .catch((e)=>{
                    console.error(e);
                    // dispatch(logout(token));
                });
            }
            else if(found.question_numbers > 0){
                GetQuestionCourseLevel(unitId, user.languaje, token, user.id)
                .then((e)=>{
                    let enterQ = 0; 
                    e.forEach(element => {
                        if(element.id > 0 && enterQ === 0){
                            enterQ++;
                            setUrl(`/question/${fatherId}/${unitId}/${element.id}`)
                        }
                    });
                })
                .catch((e)=>{
                    console.error(e);
                    // dispatch(logout(token));
                });
            }
            else{
                if(localStorage.getItem('gChildFather')){
                    setUrl(`/gchild/${localStorage.getItem('gChildFather')}/${fatherId}`)
                    if( found && found.ending_id === null ){
                        CourseEnding(token, user.id, unitId)
                        .catch((e)=>{
                            console.error(e);
                            dispatch(logout(token));
                        });
                    }
                    let enterGCUQ = 0;
                    routerInfo.forEach(element => {
                        if(element.id > parseInt(unitId) && enterGCUQ === 0){
                            enterGCUQ++;
                        }
                    });
                    if(enterGCUQ === 0){
                        setUrl(`/child/${localStorage.getItem('childFather')}/${localStorage.getItem('gChildFather')}`)
                        GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('gChildFather'))
                        .then((e)=>{
                            let found = e.find(element => element?.id === parseInt(fatherId));
                            if( found && found.ending_id === null ){
                                CourseEnding(token, user.id, fatherId)
                                .catch((e)=>{
                                    console.error(e);
                                    dispatch(logout(token));
                                });
                            }
                            let enterUQ = 0;
                            routerInfo.forEach(element => {
                                if(element.id > parseInt(fatherId) && enterUQ === 0){
                                    enterUQ++;
                                }
                            });
                            if(enterUQ === 0){
                                setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${localStorage.getItem('childFather')}`)
                                GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('childFather'))
                                .then((e)=>{
                                    let found = e.find(element => element?.id === parseInt(localStorage.getItem('gChildFather')));
                                    if( found && found.ending_id === null ){
                                        CourseEnding(token, user.id, localStorage.getItem('gChildFather'))
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                    }
                                    let enterQF = 0;
                                    e.forEach(element => {
                                        if(element.id > parseInt(localStorage.getItem('gChildFather')) && enterQF === 0){
                                            enterQF++;
                                        }
                                    });
                                    if(enterQF === 0){
                                        
                                        setUrl(`/units/${cursoId}`)
                                        GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('lessonFather'))
                                        .then((e)=>{
                                            let found = e.find(element => element?.id === parseInt(localStorage.getItem('childFather')));

                                            if( found && found.ending_id === null ){
                                                CourseEnding(token, user.id, localStorage.getItem('childFather'))
                                                .catch((e)=>{
                                                    console.error(e);
                                                    dispatch(logout(token));
                                                });
                                                const lastElement = e.pop();
                                                if(lastElement.id === parseInt(localStorage.getItem('childFather'))){
                                                    setUrl(`/finish/${cursoId}`);
                                                }
                                            }
                                            let found1 = e.find(element => element && element?.ending_id === null);
                                            if(typeof found1 === 'undefined' ){
                                                setUrl(`/finish/${cursoId}`);
                                            }
                                            
                                            let enterQFL = 0;
                                            e.forEach(element => {
                                                if(element.id > parseInt(localStorage.getItem('childFather')) && enterQFL === 0){
                                                    enterQFL++;
                                                }
                                            });
                                            if(enterQFL === 0){
                                                GetCourseFather(cursoId, user.languaje, token, user.id)
                                                .then((e)=>{
                                                    let found = e.find(element => element?.id === parseInt(localStorage.getItem('lessonFather')));
                                                    if( found && found.ending_id === null ){
                                                        CourseEnding(token, user.id, localStorage.getItem('lessonFather'))
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            dispatch(logout(token));
                                                        });
                                                    }
                                                })
                                                .catch((e)=>{
                                                    console.error(e);
                                                    //dispatch(logout(token));
                                                });
                                            }
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            //dispatch(logout(token));
                                        });
                                        
                                    }
                                })
                                .catch((e)=>{
                                    console.error(e);
                                    //dispatch(logout(token));
                                });
                                
                            }
                        })
                        .catch((e)=>{
                            console.error(e);
                            // dispatch(logout(token));
                        });
                    }        
                }
                else if(localStorage.getItem('childFather')){
                    setUrl(`/child/${localStorage.getItem('childFather')}/${fatherId}`)
                    if( found && found.ending_id === null ){
                        CourseEnding(token, user.id, unitId)
                        .catch((e)=>{
                            console.error(e);
                            dispatch(logout(token));
                        });
                    }
                    let enterUQ = 0;
                    routerInfo.forEach(element => {
                        if(element.id > parseInt(unitId) && enterUQ === 0){
                            enterUQ++;
                        }
                    });
                    if(enterUQ === 0){
                        setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${localStorage.getItem('childFather')}`)
                        GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('childFather'))
                        .then((e)=>{
                            let found = e.find(element => element?.id === parseInt(fatherId));
                            if( found && found.ending_id === null ){
                                CourseEnding(token, user.id, fatherId)
                                .catch((e)=>{
                                    console.error(e);
                                    dispatch(logout(token));
                                });
                            }
                            let enterQF = 0;
                            e.forEach(element => {
                                if(element.id > parseInt(fatherId) && enterQF === 0){
                                    enterQF++;
                                }
                            });
                            if(enterQF === 0){
                                
                                setUrl(`/units/${cursoId}`)
                                GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('lessonFather'))
                                .then((e)=>{
                                    let found = e.find(element => element?.id === parseInt(localStorage.getItem('childFather')));
                                    
                                    if( found && found.ending_id === null ){
                                        CourseEnding(token, user.id, localStorage.getItem('childFather'))
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                        const lastElement = e.pop();
                                        if(lastElement.id === parseInt(localStorage.getItem('childFather'))){
                                            setUrl(`/finish/${cursoId}`);
                                        }
                                    }
                                    let found1 = e.find(element => element && element?.ending_id === null);
                                    if(typeof found1 === 'undefined' ){
                                        setUrl(`/finish/${cursoId}`);
                                    }
                                  
                                    let enterQFL = 0;
                                    e.forEach(element => {
                                        if(element.id > parseInt(localStorage.getItem('childFather')) && enterQFL === 0){
                                            enterQFL++;
                                        }
                                    });
                                    if(enterQFL === 0){
                                        GetCourseFather(cursoId, user.languaje, token, user.id)
                                        .then((e)=>{
                                            let found = e.find(element => element?.id === parseInt(localStorage.getItem('lessonFather')));
                                            if( found && found.ending_id === null ){
                                                CourseEnding(token, user.id, localStorage.getItem('lessonFather'))
                                                .catch((e)=>{
                                                    console.error(e);
                                                    dispatch(logout(token));
                                                });
                                            }
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            //dispatch(logout(token));
                                        });
                                    }
                                })
                                .catch((e)=>{
                                    console.error(e);
                                    //dispatch(logout(token));
                                });
                                
                            }
                        })
                        .catch((e)=>{
                            console.error(e);
                            //dispatch(logout(token));
                        });
                        
                    }
                }
                else if(localStorage.getItem('lessonFather')){
                    setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${fatherId}`)
                    if( found && found.ending_id === null ){
                        CourseEnding(token, user.id, unitId)
                        .catch((e)=>{
                            console.error(e);
                            dispatch(logout(token));
                        });
                    }
                    let enterUQ = 0;
                    routerInfo.forEach(element => {
                        if(element.id > parseInt(unitId) && enterUQ === 0){
                            enterUQ++;
                        }
                    });
                    if(enterUQ === 0){
                        setUrl(`/units/${cursoId}`)
                        GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('lessonFather'))
                        .then((e)=>{
                            let found = e.find(element => element?.id === parseInt(fatherId));
                            
                            if( found && found.ending_id === null ){
                                CourseEnding(token, user.id, fatherId)
                                .catch((e)=>{
                                    console.error(e);
                                    dispatch(logout(token));
                                });
                                const lastElement = e.pop();
                                if(lastElement.id === parseInt(fatherId)){
                                    setUrl(`/finish/${cursoId}`);
                                }
                            }
                            let found1 = e.find(element => element && element?.ending_id === null);
                            if(typeof found1 === 'undefined' ){
                                setUrl(`/finish/${cursoId}`);
                            }
                            
                            let enterQFL = 0;
                            e.forEach(element => {
                                if(element.id > parseInt(fatherId) && enterQFL === 0){
                                    enterQFL++;
                                }
                            });
                            if(enterQFL === 0){
                                GetCourseFather(cursoId, user.languaje, token, user.id)
                                .then((e)=>{
                                    let found = e.find(element => element?.id === parseInt(localStorage.getItem('lessonFather')));
                                    if( found && found.ending_id === null ){
                                        CourseEnding(token, user.id, localStorage.getItem('lessonFather'))
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                    }
                                })
                                .catch((e)=>{
                                    console.error(e);
                                    //dispatch(logout(token));
                                });
                            }
                        })
                        .catch((e)=>{
                            console.error(e);
                            //dispatch(logout(token));
                        });
                                
                    }
                }
            }
            //setUrl(`/question/6/8/10`)
        }
        }
        getData(info, routerInfo);
    }, [info, routerInfo]);
 
    const parseHTML = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const body = doc.body;
    
        return Array.from(body.childNodes).map((node, index) => {
        const key = `node_${index}`;
    
        if (node.nodeType === Node.ELEMENT_NODE) {
            // Crea componentes para las etiquetas HTML necesarias
            const tagName = node.tagName.toLowerCase();
    
            if (tagName === 'b' || tagName === 'strong') {
            return <strong key={key}>{parseHTML(node.innerHTML)}</strong>;
            } else if (tagName === 'p') {
            return <p key={key}>{parseHTML(node.innerHTML)}</p>;
            }
        } else if (node.nodeType === Node.TEXT_NODE) {
            // Renderiza el texto
            return node.nodeValue;
        }
    
        return null;
        });
    };

    const disCourse = ()=>{
        try{
            return (info && url)?
            <div key={info.id} >
                <div className="img-question-back">
                {
                    (video) ? 
                    <div className="video-responsive">
                    <ReactPlayer
                    url={video}
                    width="100%"
                    controls="true"
                    />
                    </div>
                        :
                        (info.image_value_type==="svg")
                        ?
                        <img className="img-info" src = {`data:image/${info.image_value_type}+xml;base64,${base64_encode(info.image_value)}`} alt={nameUnit}/>
                        :
                        (info.image_value_type!==null)?
                        <img className="img-info" src = {`data:image/${info.image_value_type}+xml;base64,${btoa(info.image_value)}`} alt={nameUnit}/>
                        :null
                }
                </div>
                <div className="course-description" style={{whiteSpace: 'pre-line'}}>{parseHTML(info.text_value)}
                    <div className="course-enter">
                        <NavLink to={ url } className="wfp--link">
                            <Button
                                    id="btnIngresar"
                                    type="submit"
                                    className="btn m-1 btn-block btn-wfp-main betn-question-p"
                                    style={{
                                        borderColor:  cursoColor,
                                        backgroundColor: cursoColor,
                                        color:  "#ffffff",
                                    }}
                                >
                                    Continuar
                            </Button>
                        </NavLink>
                    </div>
                    <br />
                    <br />
                    <br />
                </div>
            </div>
            :null;
        
        }catch(e){
            return (info && url)?
            <div key={info.id} >
                <div className="img-question-back">
                {
                    (video) ? 
                    <div className="video-responsive">
                    <ReactPlayer
                    url={video}
                    width="100%"
                    controls="true"
                    />
                    </div>
                        :null
                }
                </div>
                <div className="course-description" style={{whiteSpace: 'pre-line'}}>{parseHTML(info.text_value)}
                    <div className="course-enter">
                        <NavLink to={ url } className="wfp--link">
                            <Button
                                    id="btnIngresar"
                                    type="submit"
                                    className="btn m-1 btn-block btn-wfp-main betn-question-p"
                                    style={{
                                        borderColor:  cursoColor,
                                        backgroundColor: cursoColor,
                                        color:  "#ffffff",
                                    }}
                                >
                                    Continuar
                            </Button>
                        </NavLink>
                    </div>
                    <br />
                    <br />
                    <br />
                </div>
            </div>
            :null;
        }
        
    }
    
    return (
        <div className="fund-main-unit">
            <Navbar title={cursoNombre}/>
            <div className="text-title"
            style={{
                backgroundColor: cursoColor,
                color:  "#ffffff",
            }}
            >{nameUnit && nameUnit}</div>

            {
                course && (course.background_home_type==="svg")
                ?
                <img className="fund-start-b-imgu" src = {`data:image/svg+xml;base64,${base64_encode(course.background_home)}`} alt="Back Ground"/>
                :
                (course.background_home_type!==null)?
                <img className="fund-start-b-imgu" src = {`data:image/${info.background_home_type}+xml;base64,${btoa(info.background_home)}`} alt="Back Ground"/>
                :null
            }
            
            <div className="content-course" >
                {!course && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>} 
                {info && disCourse() }
            </div>
        </div>
    )
}

